module.exports = __webpack_public_path__ + "media/applicants/icon-passed-quiz-5820114b.png";